import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Example usage of the styled button
const CustomButton = ({
  children, className, onClick, mainColor, disabled, style, accessibilityRole
}) => {
  // Define colors
  const theme = {
    gray: '#767676',
    lightGray: '#E0E1E2',
    rcActions: mainColor || '#2185D0',
    rcAqua: '#15CEC4',
    rcBlack: '#0A1514',
    rcGreen: '#56C12E',
    rcOrange: '#FFB11A',
    rcRed: '#FE1A20',
    rcRoyal: mainColor || '#002391',
    rcTorq: '#C4E8E7',
  };

  // Styled button component
  const StyledButton = styled.button`
    border: none;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
    border-radius: 8px;
    display: block;
    width: 100%;
    padding: 17px 20px;
    font-weight: bold;
    outline: none;
    margin-bottom: 10px;
  
    &.gray-btn {
      background-color: ${theme.lightGray} !important;
      color: ${theme.gray} !important;
    }
  
    &.outline {
      background-color: white;
      border-width: 2px;
      border-style: solid;
  
      &:disabled {
        color: ${theme.lightGray} !important;
        border-color: ${theme.lightGray} !important;
      }
  
      &.royal {
        border-color: ${theme.rcRoyal} !important;
        color: #002391 !important;
      }
  
      &.cta {
        border-color: ${theme.rcActions} !important;
        color: #2185D0 !important;
      }
    }
  
    &.filled {
      &.royal {
        background-color: ${theme.rcRoyal} !important;
        color: white;
      }
  
      &.cta {
        background-color: ${theme.rcActions} !important;
        color: white;
      }
    }
`;

  return (
    <StyledButton
      style={style}
      disabled={disabled}
      className={className}
      onClick={onClick}
      accessibilityRole={accessibilityRole}
      role={accessibilityRole}
    >
      {children}
    </StyledButton>
  );
};

const mapStateToProps = (store) => ({
  mainColor: store.app?.mainColor || '#002391',
});

export default connect(mapStateToProps, null)(CustomButton);
